export default __webpack_public_path__ + "static/media/ui.877c16db.png";